export type CliDiagnosticValue = string | number | boolean | null;
export type CliDiagnosticMetadata = Record<string, CliDiagnosticValue>;

const DIAGNOSTIC_METADATA_KEY = '__chatsdetCliDiagnosticMetadata';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function isCliDiagnosticMetadata(value: unknown): value is CliDiagnosticMetadata {
  if (!isRecord(value)) return false;
  return Object.values(value).every(
    (item) =>
      typeof item === 'string' ||
      typeof item === 'number' ||
      typeof item === 'boolean' ||
      item === null
  );
}

export function attachCliDiagnosticMetadata(
  error: unknown,
  metadata: CliDiagnosticMetadata
): unknown {
  if (!isRecord(error)) return error;
  const existing = isCliDiagnosticMetadata(error[DIAGNOSTIC_METADATA_KEY])
    ? error[DIAGNOSTIC_METADATA_KEY]
    : {};
  error[DIAGNOSTIC_METADATA_KEY] = { ...existing, ...metadata };
  return error;
}

export function getCliDiagnosticMetadata(error: unknown): CliDiagnosticMetadata {
  if (!isRecord(error)) return {};
  const metadata = error[DIAGNOSTIC_METADATA_KEY];
  return isCliDiagnosticMetadata(metadata) ? metadata : {};
}
